import React, { Fragment } from "react";
import MDEditor from "rich-markdown-editor";

const JobDescription = ({ job }) => (
  <MDEditor
    defaultValue={job.description}
    value={job.description}
    readOnly={true}
  />
);

export default JobDescription;

// export default createFragmentContainer(JobDescription, {
//   job: graphql`
//     fragment JobDescription_job on JobNode {
//       description
//     }
//   `
// });
